export const termsHtml = /*html*/`
`;